import { debounce } from 'lodash';
import { takeEvery, takeOnce } from '../../listenerMiddleware';
import * as appActions from '../app/actions';
import { getUser } from '../app/selectors';
import * as filtersCacheActions from './actions';
import {
  dropForeignFiltersCaches,
  loadPersistedFiltersCache,
  savePersistedFiltersCache,
} from './persistentCache';
import { getFiltersCache } from './selectors';
import { FiltersCacheShape } from './model';

export const filtersCacheListeners = () => {
  watchHydration();
  watchPersistence();
};

// Гидрация кэша словарей из localStorage при старте (для залогиненного пользователя).
// userLoaded диспатчится в bootstrap (index.tsx) ДО main(), а значит и до первого запроса
// словарей (он уходит на первый pagePathChanged) — к этому моменту кэш прошлой сессии уже
// в сторе. Для анонимных страниц (шаренные ссылки) userLoaded не диспатчится — гидрации
// нет, и это ожидаемо: там свои фильтры и свой пользователь неизвестен.
function watchHydration() {
  takeOnce(appActions.userLoaded, ({ payload }, { dispatch }) => {
    const userId = String(payload.user.id);
    dropForeignFiltersCaches(userId);

    const cache = loadPersistedFiltersCache(userId);
    if (Object.keys(cache).length > 0) {
      dispatch(filtersCacheActions.hydrated({ cache }));
    }
  });
}

// Персист кэша при каждом обновлении. Дебаунс — потому что при смене проекта четыре
// словаря обновляются почти одновременно, и писать localStorage четыре раза подряд незачем.
function watchPersistence() {
  const save = debounce((userId: string, cache: FiltersCacheShape) => {
    savePersistedFiltersCache(userId, cache);
  }, 500);

  takeEvery(filtersCacheActions.stored, (action, { getState }) => {
    const user = getUser(getState());
    if (!user) {
      return;
    }
    save(String(user.id), getFiltersCache(getState()));
  });
}
